module.exports = __webpack_public_path__ + "static/media/covered_warranty_BG.d2e67287.png";